// @flow
import ActionCollection from "../actions/ActionCollection";
import ResourceModel from "../base/ResourceModel";

import ModularUIResponse from "../../modularui/ModularUIResponse";
import type { ModelOptions } from "../types";

/**
 * TaskGroupModel
 */
export default class TaskGroupModel extends ResourceModel {
  _key: string;
  _actionCollection: ActionCollection;

  /**
   */
  constructor(modularuiResponse: ModularUIResponse) {
    super(modularuiResponse);

    this._actionCollection = new ActionCollection(
      this.data.actions,
      this.contributions.actions,
      this.modelOptions,
    );

    const selfHref = this.links.getLinkByKey("self")
      ? this.selflink.href.href
      : null;

    this._key = selfHref
      ? selfHref.substring(selfHref.lastIndexOf("/") + 1)
      : this.data.name;
  }

  /**
   */
  static create(
    key: string,
    data: Object,
    contributions: Object,
    modelOptions?: ModelOptions,
  ): TaskGroupModel {
    const taskgroup = new ModularUIResponse();
    taskgroup.key = key;
    taskgroup.data = data;
    taskgroup.contributions = contributions;
    taskgroup.origin = modelOptions?.origin;
    taskgroup.contextPath = modelOptions?.contextPath;

    return new TaskGroupModel(taskgroup);
  }

  /**
   */
  get type(): string {
    return "TaskGroup";
  }

  /**
   */
  static get modelName(): string {
    return "TaskGroupModel";
  }

  /**
   */
  static isApplicableModel(data: ModularUIResponse): boolean {
    return (
      data.contributions.resourcetype &&
      data.contributions.resourcetype === "TaskGroup"
    );
  }

  /**
   * Get the key of the TaskGroup
   */
  get key(): string {
    return this._key;
  }

  /**
   * Get the label of the TaskGroup
   */
  get label(): string {
    return this.contributions.label;
  }

  /**
   * Retrieve actions of taskgroup
   */
  get actionCollection(): ActionCollection {
    return this._actionCollection;
  }

  /**
   * Indicates if taskgroup has tasks
   * @returns {boolean}
   */
  hasTasks(): boolean {
    return this.actionCollection.length > 0;
  }
}
